const AGO = ["12 min ago", "48 min ago", "2 hrs ago", "5 hrs ago", "9 hrs ago"];

// Flat platform fee charged on every Offer to Buy / Offer to Sell transaction.
export const TRADE_FEE = 100;

const buildOrders = (price, members) => ({
  buy: [2, 1, 4, 2, 3].map((fractions, i) => ({
    fractions,
    price: Math.round((price * (1 + [0.032, 0.026, 0.018, 0.011, 0.005][i])) / 50) * 50,
    member: members[i],
    ago: AGO[i],
  })),
  sell: [3, 2, 1, 5, 2].map((fractions, i) => ({
    fractions,
    price: Math.round((price * (1 + [0.045, 0.038, 0.03, 0.022, 0.015][i])) / 50) * 50,
    member: members[i + 5],
    ago: AGO[i],
  })),
});

export const SCRIPS = [
  {
    scrip: "MCDHSR",
    title: "Artisanal Chai & QSR Cafe",
    city: "Indiranagar, Bengaluru",
    sector: "F&B & Cafes",
    img: "https://images.unsplash.com/photo-1766904413712-df0e9349e89f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjByZXRhaWwlMjBzdG9yZSUyMGNhZmUlMjBidXNpbmVzc3xlbnwwfHx8fDE3ODc3Mzk0NzF8MA&ixlib=rb-4.1.0&q=85",
    min: "₹5,000",
    fractionPrice: 5000,
    totalFractions: 900,
    target: "₹45,00,000",
    projectCost: "₹1,12,50,000",
    irr: "18–22%",
    tenure: "5 Years",
    funded: 72,
    members: 144,
    raised: "₹32,40,000",
    status: "Funding Open",
    operator: "ChaiCraft Foods Pvt. Ltd. (FOCO model)",
    instrument: "Compulsorily Convertible Debentures (CCDs)",
    outletSize: "650 sq.ft high-street cafe",
    financials: { monthlyRevenue: 740000, monthlyExpenses: 520000, investorShare: 38 },
    payoutHistory: [
      { month: "Mar '26", amount: 84 },
      { month: "Apr '26", amount: 88 },
      { month: "May '26", amount: 91 },
      { month: "Jun '26", amount: 93 },
    ],
    poolSample: [
      { id: "M-0142", fractions: 6, city: "Bengaluru" },
      { id: "M-0287", fractions: 3, city: "Mumbai" },
      { id: "M-0319", fractions: 9, city: "Pune" },
      { id: "M-0455", fractions: 2, city: "Delhi" },
      { id: "M-0521", fractions: 5, city: "Hyderabad" },
      { id: "M-0678", fractions: 4, city: "Chennai" },
      { id: "M-0734", fractions: 8, city: "Bengaluru" },
      { id: "M-0812", fractions: 2, city: "Jaipur" },
    ],
    orders: buildOrders(5000, ["M-0911", "M-0234", "M-1102", "M-0476", "M-0859", "M-1027", "M-0368", "M-0745", "M-1290", "M-0513"]),
  },
  {
    scrip: "FITBND",
    title: "Modern Tech-Enabled Gym",
    city: "Bandra, Mumbai",
    sector: "Health & Fitness",
    img: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=940&q=80",
    min: "₹10,000",
    fractionPrice: 10000,
    totalFractions: 850,
    target: "₹85,00,000",
    projectCost: "₹2,12,50,000",
    irr: "19–24%",
    tenure: "5 Years",
    funded: 54,
    members: 108,
    raised: "₹45,90,000",
    status: "Funding Open",
    operator: "FitSphere Wellness (Master franchise)",
    instrument: "Non-Convertible Debentures (NCDs)",
    outletSize: "2,400 sq.ft smart fitness studio",
    financials: { monthlyRevenue: 1250000, monthlyExpenses: 930000, investorShare: 40 },
    payoutHistory: [
      { month: "Mar '26", amount: 138 },
      { month: "Apr '26", amount: 145 },
      { month: "May '26", amount: 149 },
      { month: "Jun '26", amount: 151 },
    ],
    poolSample: [
      { id: "M-0118", fractions: 3, city: "Mumbai" },
      { id: "M-0244", fractions: 7, city: "Thane" },
      { id: "M-0377", fractions: 2, city: "Bengaluru" },
      { id: "M-0462", fractions: 4, city: "Delhi NCR" },
      { id: "M-0590", fractions: 3, city: "Mumbai" },
      { id: "M-0633", fractions: 6, city: "Ahmedabad" },
      { id: "M-0781", fractions: 2, city: "Pune" },
      { id: "M-0846", fractions: 3, city: "Surat" },
    ],
    orders: buildOrders(10000, ["M-0955", "M-0211", "M-1178", "M-0430", "M-0822", "M-1066", "M-0341", "M-0719", "M-1233", "M-0588"]),
  },
  {
    scrip: "CLDBRY",
    title: "Cloud Kitchen & Biryani Co.",
    city: "Gurugram, Delhi NCR",
    sector: "Cloud Kitchens",
    img: "https://images.unsplash.com/photo-1682778418768-16081e4470a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBmcmFuY2hpc2UlMjBmb29kJTIwc3RvcmUlMjByZXN0YXVyYW50fGVufDB8fHx8MTc4NzczOTQ3Nnww&ixlib=rb-4.1.0&q=85",
    min: "₹5,000",
    fractionPrice: 5000,
    totalFractions: 700,
    target: "₹35,00,000",
    projectCost: "₹87,50,000",
    irr: "20–25%",
    tenure: "3 Years",
    funded: 81,
    members: 162,
    raised: "₹28,35,000",
    status: "Closing Soon",
    operator: "DumHouse Kitchens Pvt. Ltd.",
    instrument: "Compulsorily Convertible Debentures (CCDs)",
    outletSize: "900 sq.ft delivery-first kitchen",
    financials: { monthlyRevenue: 980000, monthlyExpenses: 715000, investorShare: 42 },
    payoutHistory: [
      { month: "Mar '26", amount: 146 },
      { month: "Apr '26", amount: 153 },
      { month: "May '26", amount: 157 },
      { month: "Jun '26", amount: 159 },
    ],
    poolSample: [
      { id: "M-0105", fractions: 5, city: "Gurugram" },
      { id: "M-0276", fractions: 2, city: "Delhi" },
      { id: "M-0354", fractions: 3, city: "Noida" },
      { id: "M-0419", fractions: 7, city: "Bengaluru" },
      { id: "M-0567", fractions: 2, city: "Lucknow" },
      { id: "M-0648", fractions: 4, city: "Chandigarh" },
      { id: "M-0752", fractions: 9, city: "Mumbai" },
      { id: "M-0893", fractions: 2, city: "Indore" },
    ],
    orders: buildOrders(5000, ["M-0988", "M-0267", "M-1145", "M-0402", "M-0871", "M-1093", "M-0326", "M-0764", "M-1251", "M-0547"]),
  },
  {
    scrip: "MRTKOR",
    title: "Quick Mart & Pharmacy Outlet",
    city: "Koramangala, Bengaluru",
    sector: "Retail & Marts",
    img: "https://images.pexels.com/photos/26861411/pexels-photo-26861411.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    min: "₹10,000",
    fractionPrice: 10000,
    totalFractions: 600,
    target: "₹60,00,000",
    projectCost: "₹1,50,00,000",
    irr: "16–20%",
    tenure: "5 Years",
    funded: 38,
    members: 76,
    raised: "₹22,80,000",
    status: "Funding Open",
    operator: "NeighbourKart Retail LLP",
    instrument: "Non-Convertible Debentures (NCDs)",
    outletSize: "1,100 sq.ft neighbourhood mart",
    financials: { monthlyRevenue: 1580000, monthlyExpenses: 1360000, investorShare: 36 },
    payoutHistory: [
      { month: "Mar '26", amount: 121 },
      { month: "Apr '26", amount: 127 },
      { month: "May '26", amount: 130 },
      { month: "Jun '26", amount: 132 },
    ],
    poolSample: [
      { id: "M-0133", fractions: 3, city: "Bengaluru" },
      { id: "M-0298", fractions: 2, city: "Mysuru" },
      { id: "M-0340", fractions: 4, city: "Mangaluru" },
      { id: "M-0487", fractions: 2, city: "Chennai" },
      { id: "M-0515", fractions: 3, city: "Kochi" },
      { id: "M-0669", fractions: 6, city: "Bengaluru" },
      { id: "M-0727", fractions: 2, city: "Coimbatore" },
      { id: "M-0854", fractions: 3, city: "Hubballi" },
    ],
    orders: buildOrders(10000, ["M-0922", "M-0249", "M-1130", "M-0498", "M-0816", "M-1044", "M-0385", "M-0701", "M-1276", "M-0529"]),
  },
];

export const MATCHED_TRADES = [
  "CLDBRY · 3 fractions matched at ₹5,220",
  "MCDHSR · 2 fractions matched at ₹5,160",
  "FITBND · 1 fraction matched at ₹10,380",
  "MRTKOR · 4 fractions matched at ₹10,450",
];
